import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/ticket_black.svg")